import {AbstractControl, ValidatorFn} from '@angular/forms';
import _ from 'lodash';

export const  confirmPasswordValidator: ValidatorFn = (control: AbstractControl) => {

  if (control.get('password').value === control.get('confirm-password').value){
    return null;
  }
  if (_.isEmpty(control.get('password').value) && _.isEmpty(control.get('confirm-password').value)){
    return null;
  }

  return { mismatch: true };
};

